import { Button } from "~/components/ui/button";
import type { ProjectTaskBoard } from "./useProjectTaskBoard";
import type { ProjectTaskViewProps } from "./taskViewTypes";
import { ProjectTaskListView } from "./ProjectTaskListView";
import { ProjectTaskBoardView } from "./ProjectTaskBoardView";
import { ProjectTaskTimelineView } from "./ProjectTaskTimelineView";

interface ProjectTaskSurfaceBodyProps {
  readonly view: "list" | "board" | "timeline";
  readonly loading: boolean;
  readonly error: string | null;
  readonly viewProps: ProjectTaskViewProps;
  readonly onMoveTask: ProjectTaskBoard["moveTask"];
  readonly reorderingDisabled: boolean;
  readonly mutationDisabled: boolean;
  readonly onRetry: () => void;
}

export function ProjectTaskSurfaceBody(props: ProjectTaskSurfaceBodyProps) {
  if (props.error) {
    return (
      <div className="flex min-h-[160px] flex-col items-center justify-center gap-2 p-6">
        <p className="text-sm text-destructive">{props.error}</p>
        <Button type="button" size="sm" variant="outline" onClick={props.onRetry}>
          Retry
        </Button>
      </div>
    );
  }
  if (props.loading) {
    return <p className="p-6 text-sm text-muted-foreground">Loading tasks…</p>;
  }
  if (props.view === "list") {
    return <ProjectTaskListView {...props.viewProps} mutationDisabled={props.mutationDisabled} />;
  }
  if (props.view === "board") {
    return (
      <ProjectTaskBoardView
        {...props.viewProps}
        onMoveTask={props.onMoveTask}
        reorderingDisabled={props.reorderingDisabled}
        mutationDisabled={props.mutationDisabled}
      />
    );
  }
  return <ProjectTaskTimelineView {...props.viewProps} />;
}
